
import React from 'react';
import { Navigate } from 'react-router-dom';

const isTokenExpired = (token) => {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp * 1000 < Date.now();
  } catch {
    return true;
  }
};

const PublicRoute = ({ children }) => {
  const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
  const is2FAVerified = localStorage.getItem('is2FAVerified') === 'true';
  const token = localStorage.getItem('jwtToken');

  // If token is expired, treat as not logged in
  if (token && isTokenExpired(token)) {
    return children;
  }

  // If logged in but not 2FA verified, redirect to 2FA page
  if (isLoggedIn && !is2FAVerified && token) {
    return <Navigate to="/2fa" replace />;
  }

  // If already logged in and 2FA-verified, redirect to dashboard
  if (isLoggedIn && is2FAVerified && token) {
    return <Navigate to="/dashboard" replace />;
  }

  // Otherwise, show the page (login, reset-password, etc.)
  return children;
};

export default PublicRoute;
